import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { AuthserviceService } from '../services/authservice.service';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { AppSessionStorageService } from '../services/utils/session-storage.service';
import { CommonService } from '../services/common/common.service';
import { RouteConstants } from '../constants/route-constants';

@Injectable()
export class AuthenticationInterceptorInterceptor implements HttpInterceptor {
  constructor(
    private _identityService: AuthserviceService,
    private router: Router,
    private storage: StorageService,
    private commonService: CommonService
  ) {}

  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get JWT
    let jwt = this._identityService.getAccessToken();
    if (AppSessionStorageService.grantAccess?.access_token) {
      jwt = AppSessionStorageService.grantAccess?.access_token;
    }
    const refresh_token = this._identityService.getRefreshToken();

    // setting jwt token as header on request
    if (httpRequest.url.includes('refresh_token')) {
      // For refresh token API, append 'Refresh' as the Bearer token prefix
      return next
        .handle(
          httpRequest.clone({
            setHeaders: { Authorization: `Bearer ${refresh_token}` },
          })
        )
        .pipe(
          catchError((response) => {
            this.responseHandler(response);
            this.sessionKickOut(response);
            return of(response);
          })
        );
    }
    return next
      .handle(
        httpRequest.clone({ setHeaders: { authorization: `Bearer ${jwt}` } })
      )
      .pipe(
        catchError((response) => {
          if (
            response.status == 401 &&
            response.error.message.toLocaleLowerCase() == 'token has expired' &&
            this._identityService.isLoggedIn()
          ) {
            this._identityService.refeshToken();
          }
          this.responseHandler(response);
          this.signinPageLoader(response);
          return throwError(() => response);
        })
      );
  }

  sessionKickOut(response:any){
    if (response.status === 401) {
      this._identityService.logout();
    }
    return of(response);
  }

  errorMessageSave(response:any){
    if (response.error.message) {
      this.storage.saveToLocalStorage(
        'message',
        response.error.message
      );
    }
  }

  responseHandler(response:any){
    if (response.status === 401) {
      this._identityService.logout();
      this.errorMessageSave(response);
    }
    else if (
      response.status === 422 &&
      response.error.message === 'Invalid captcha token'
    ) {
      this.router.navigate(['error']);
    } else if (response.status == 422 && AppSessionStorageService.grantAccess==null) {
      //logout end user on 422 status code
      this._identityService.logout();
    }
  }

  signinPageLoader(response:any){
    if (response?.value) {
      const encryptData = response;
      this.commonService.updateKey(encryptData);
      if (
        AppSessionStorageService.auth &&
        encryptData.auth == undefined
      ) {
        this.router.navigate([RouteConstants.SIGNIN]);
      }
    }
  }
  
}
